var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('navigation'),_c('v-main',{class:{'pt-0': _vm.$route.name === 'Home'}},[_c('router-view')],1),_c('foot'),_c('alert-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }